import {createUseStyles} from 'react-jss';
import {FC, ReactNode} from 'react';
import {DetailRow, DetailRowProps} from 'common/components/detail-row';
import {CssBreakpoints} from 'styles/responsive';

const useListDetailRowStyles = createUseStyles({
  list: {
    padding: '0',
  },
  listElement: {
    listStyleType: 'none',
    marginLeft: '0',
  },
  [`@media (max-width: ${CssBreakpoints.MD}px)`]: {
    list: {
      marginTop: '0',
      marginBottom: '0',

      '& > :first-child': {
        marginTop: '0',
      },
      '& > :last-child': {
        marginBottom: '0',
      },
    },
  },
});

interface ListDetailRowProps extends DetailRowProps {
  children: ReactNode[];
}

interface ListItemProps {
  children: ReactNode;
}

export const ListDetailRow: FC<ListDetailRowProps> = ({children, ...detailRowProps}) => {
  const styles = useListDetailRowStyles();

  return (
    children && (
      <DetailRow {...detailRowProps}>
        <ul className={styles.list}>{children}</ul>
      </DetailRow>
    )
  );
};

export const ListItem: FC<ListItemProps> = ({children, ...props}) => {
  const styles = useListDetailRowStyles();

  return (
    <li className={styles.listElement} {...props}>
      {children}
    </li>
  );
};
